import { Dispatch } from 'react';

export interface LibraryThumbnailPreviewState {
  imageBroken: boolean;
}
export interface LibraryThumbnailPreviewProps {
  imageUrl?: string;
}
export interface Action {
  type: ACTION_TYPE;
  payload?: any;
}

export enum ACTION_TYPE {
  BROKEN = 'BROKEN',
}

export function reducer(state: LibraryThumbnailPreviewState, action: Action): LibraryThumbnailPreviewState {
  switch (action.type) {
    case ACTION_TYPE.BROKEN:
      return { ...state, imageBroken: action.payload };
    default:
      throw new Error('Invalid Action Type: ' + action.type);
  }
}
